import makeStyles from '@material-ui/core/styles/makeStyles';

const drawerWidth = 230;

export default makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: ({ maintenanceStartTime }) =>
      theme.zIndex.drawer + (maintenanceStartTime < 0 ? 201 : 1),
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    minHeight: 60,
    backgroundColor: theme.palette.background.defaultLightGrey,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    '& div': {
      backgroundColor:
        theme.palette.type === 'light'
          ? theme.palette.background.defaultLightGrey
          : theme.palette.background.default,
      borderRight: 'none',
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolbarSpacing: {
    // necessary for content to be below app bar
    marginTop: ({ maintenanceStartTime }) =>
      maintenanceStartTime ? '94px' : '64px',
  },
  drawerIcon: {
    backgroundSize: 'cover',
    width: '23px',
    height: '23px',
    backgroundRepeat: 'no-repeat',
    '&:active': {
      backgroundPosition: '-25px',
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  listItem: {
    height: '42px',
    width: '100%',
    padding: '8px 12px',
    borderLeft: '4px solid transparent',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  listItemIcon: {
    minWidth: '30px',
    marginLeft: 0,
  },
  fadeOutElement: {
    opacity: 1,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  activeListItem: {
    // backgroundColor: theme.palette.background.sidebarActiveItem,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    '& div': {
      // backgroundColor: theme.palette.background.sidebarActiveItem,
    },
    '& span': {
      color:
        theme.palette.type === 'light'
          ? theme.palette.primary.main
          : theme.palette.text.primary,
    },
    '& .sidebar-list-icon': {
      display: 'none',
    },
    '& .sidebar-list-active-icon': {
      display: 'block',
    },
  },
  poweredBy: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontFamily: theme.font.medium,
    color: theme.palette.grey[500],
    backgroundColor: theme.palette.background.defaultLightGrey,
    position: 'fixed',
    bottom: 0,
    height: 50,
    '& img': {
      width: '20px',
      marginLeft: 8,
      marginRight: '8px',
    },
    '& p': {
      fontSize: theme.typography.fontSize,
      letterSpacing: '0.5px',
      marginBottom: '16px',
    },
    '& div': {
      fontSize: '12px',
      letterSpacing: '0.17px',
      textAlign: 'left',
    },
  },
  contentContainer: {
    position: 'relative',
    // width: `calc(100% - ${drawerWidth}px)`,
  },
}));
